/*
 *
 * Defines variables and sets the scope actions for equipment management page
 * This component is in dire need of a major rework -Bin
 *
 * @authors: Lots of peeps, clearly
 * @date Aug 2014
 *
 */
import _ from 'lodash';
import { SECOND } from 'Utils/time';
import equipGridOptions from './equipmentGrid.value';
import addRcuModal from './addRcu.modal.component';
import disableEventsModal from './disableEvents.modal.component';
import equipmentManagementModal from './equipmentManagement.modal.component';
import { setTitle } from 'Utils';
import template from './equipment.html';

const NETBIRD_IP_START = '100.86.';
const TEN_T_IP_START = '10.';

/* @ngInject */
function EquipmentController(
  $q,
  $scope,
  $state,
  $stateParams,
  $transitions,
  $uibModal,
  $element,
  $timeout,
  $window,
  growl,
  EquipmentService,
  RcuService,
  EquipmentInfoService,
  RcuInfoService,
  ModalService,
  uiGridConstants,
) {
  const vm = this;
  let allEquipment = [];
  let gotAllEquipment;
  const SAVED_GRID_STATE_KEY = 'equipment.grid.legacy.state';

  vm.allRcus = [];

  vm.$onInit = init;
  vm.$postLink = postLink;
  vm.$onDestroy = $onDestroy;
  vm.selectRcu = selectRcu;
  vm.syncRcu = syncRcu;
  vm.syncRcuModal = syncRcuModal;
  vm.powerCycleCellular = powerCycleCellular;
  vm.powerCycleEquipment = powerCycleEquipment;
  vm.deleteRcu = deleteRcu;
  vm.deleteRcuModal = deleteRcuModal;
  vm.deleteEquipment = deleteEquipment;
  vm.deleteEquipmentModal = deleteEquipmentModal;
  vm.disableEvents = disableEvents;
  vm.openRcuModal = openRcuModal;
  vm.openEquipmentModal = openEquipmentModal;

  const transitions = [
    $transitions.onBefore(
      { to: 'admin.equipment' },
      () => { setTitle(vm.currentRcu?.name || 'Equipment') }
    ),
    $transitions.onSuccess(
      { to: 'admin.equipment.edit' },
      async () => {
        !vm.currentEquipment && await selectEquipment();
        setTitle(`Edit ${vm.currentEquipment.name}`);
        openEquipmentModal(true);
      }),
    $transitions.onSuccess(
      { to: 'admin.equipment.new' },
      () => {
        setTitle('New Equipment');
        openEquipmentModal();
      }),
    $transitions.onSuccess(
      { to: 'admin.equipment.eq' },
      async (transition) => {
        await selectEquipment(transition.targetState().params().id);
        setTitle(vm.currentEquipment.name);
      }),
  ];

  // Save the grid state into local storage
  vm.saveGridState = function saveGridState() {
    const state = vm.gridApi.saveState.save();
    localStorage.setItem(SAVED_GRID_STATE_KEY, JSON.stringify(state));
  };

  vm.saveDefaultGridState = function saveDefaultGridState() {
    vm.defaultGridState = vm.gridApi.saveState.save();
  };

  // Restore the grid state from local storage
  vm.restoreGridState = function restoreGridState() {
    let gridState;
    try {
      gridState = JSON.parse(localStorage.getItem(SAVED_GRID_STATE_KEY));
    } catch {
      localStorage.removeItem(SAVED_GRID_STATE_KEY);
    }
    if (_.isPlainObject(gridState) && _.keys(gridState).length) {
      vm.gridApi.saveState.restore(vm, gridState);
    }
  };

  // Reset the grid state to the default state
  vm.resetGridState = function resetGridState() {
    vm.gridApi.saveState.restore(vm, vm.defaultGridState)
      .then(() => {
        const state = vm.gridApi.saveState.save();
        localStorage.setItem(SAVED_GRID_STATE_KEY, JSON.stringify(state));
      });
  };

  function init() {
    RcuInfoService.subscribeToAdmin();
    RcuInfoService.getAllRcus()
      .then((foundRcus) => {
        vm.allRcus = foundRcus;
      });

    EquipmentInfoService.setNeed('admin_equipment');
    gotAllEquipment = EquipmentInfoService.getAllEquipments()
      .then((foundEquipment) => {
        allEquipment = foundEquipment;
        updateGridWithEquipment();
      });

    // TODO: Handle navigation to /new
    // This is not presently meaningful since the page needs an RCU selection to begin

    // Options object passed into the ui-grid directive
    vm.gridOptions = equipGridOptions;
    vm.gridOptions.appScopeProvider = vm;
    vm.gridOptions.onRegisterApi = (gridApi) => {
      vm.gridApi = gridApi;

      const initialColumnChange = vm.gridApi.grid.registerDataChangeCallback(() => {
        vm.saveDefaultGridState();
        // Restore previously saved state.
        vm.restoreGridState();
        initialColumnChange();
      }, [uiGridConstants.dataChange.COLUMN]);

      gridApi.selection.on.rowSelectionChanged($scope, async (row) => {
        const deselection = !row.isSelected;
        if (deselection) {
          await selectRcu(vm.currentRcu);
          vm.currentEquipment = undefined;
          return void $state.go('admin.equipment');
        }

        const { entity: eq } = row;
        vm.currentEquipment = eq;
        if (!vm.currentEquipmentRcu) {
          await selectRcu();
        }
        if ((eq.equipmentType === 'cameras' || eq.equipmentType === 'radar') &&
          _.has(eq, ['settings', 'externalIp']) &&
          _.has(eq, ['settings', 'externalPort'])) {
          eq.url = `${eq.settings.protocol || 'http'}://${eq.settings.externalIp}:${eq.settings.externalPort}/`;
        }

        /*
          Normally we could rely on ui-router to ignore state change and not worry about invoking this superfluously
          but we need to skip not only retained '.equipment.eq' state but also for '.equipment.edit'
        */
        $state.params.id !== eq.id && $state.go('admin.equipment.eq', { id: eq.id });
        scrollToSelection();
      });

      // Setup events so we're notified when grid state changes.
      vm.gridApi.colMovable.on.columnPositionChanged($scope, vm.saveGridState);
      vm.gridApi.colResizable.on.columnSizeChanged($scope, vm.saveGridState);
      vm.gridApi.core.on.columnVisibilityChanged($scope, vm.saveGridState);
      vm.gridApi.core.on.filterChanged($scope, vm.saveGridState);
      vm.gridApi.core.on.sortChanged($scope, vm.saveGridState);
    };

    // Handle routes manually for initial load (transition hooks not registered yet)
    switch ($state.current.name) {
      case 'admin.equipment':
        setTitle('Equipment');
        break;
      case 'admin.equipment.edit':
        selectEquipment().then(() => setTitle(`Edit ${vm.currentEquipment.name}`));
        openEquipmentModal(true);
        break;
      case 'admin.equipment.eq':
        selectEquipment().then(() => setTitle(vm.currentEquipment.name));
        break;
      case 'admin.equipment.new':
        // TODO: It doesn't currently make sense to open the modal because there is no way of determining RCU
        $state.go('admin.equipment');
        break;
      default:
    }
  }

  async function selectEquipment(id = $stateParams.id) {
    await $q.resolve(gotAllEquipment);
    vm.currentEquipment = _.find(allEquipment, { id });

    const selectionOutOfBounds = !_.some(vm.gridOptions.data, { id });
    const selectionNonExistent = !vm.currentEquipment;
    if (selectionOutOfBounds) {

      /**
       * ? This occurs when the user has selected an equipment that does not exist in the currently selected RCU
       * ? because the grid is not idiomatically filtered and instead uses a homespun hack. E.g.: Quickfinding an
       * ? equipment while currently "filtering" by a different RCU.
       */
      if (selectionNonExistent) {
        console.warn('Attempted selection of nonexistent : ', id);
        $state.go('admin.equipment');
      } else {
        await selectRcu(vm.currentEquipment.rcu);
      }
    }
    vm.gridApi.selection.selectRow(_.find(vm.gridOptions.data, { id }));
  }

  function scrollToSelection() {
    const [row] = vm.gridApi.selection.getSelectedGridRows();
    vm.gridApi.core.scrollToIfNecessary(row, vm.gridOptions.columnDefs[0]);
  }

  function postLink() {
    // swap those nasty abbr elements:
    const abbrDestroy = $scope.$watch(() => angular.element('abbr').length === 2, (__, newV) => {
      if (newV) {
        angular.element('abbr').replaceWith((nn) => {
          if (nn === 0) {
            return '<abbr> / </abbr>';
          }
          return '<abbr> - </abbr>';
        });
        abbrDestroy();
      }
    });

    // Detect when .rcu-actions wraps to its own flex line so the dropdown can open rightward
    const checkActionsWrapped = () => {
      const titleRow = $element[0].querySelector('.rcu-title-row');
      const actions = $element[0].querySelector('.rcu-actions');
      if (!titleRow || !actions) { return }
      const wrapped = actions.getBoundingClientRect().top > titleRow.getBoundingClientRect().top + 5;
      if (wrapped !== vm.actionsWrapped) {
        $scope.$evalAsync(() => { vm.actionsWrapped = wrapped });
      }
    };
    const debouncedCheck = _.debounce(checkActionsWrapped, 100);
    $timeout(checkActionsWrapped);
    // Re-check when equipment/RCU selection changes, since the buttons render via ng-if
    // and the DOM isn't updated until after the current digest.
    $scope.$watchGroup(
      [() => vm.currentEquipment, () => vm.currentRcu],
      () => $timeout(checkActionsWrapped)
    );
    $window.addEventListener('resize', debouncedCheck);
    vm._cleanupActionsWrapped = () => {
      $window.removeEventListener('resize', debouncedCheck);
      debouncedCheck.cancel();
    };
  }

  function setMinRowsToShow() {
    // if data length is smaller, we shrink. otherwise we can do pagination.
    vm.gridOptions.minRowsToShow = vm.gridOptions.data.length;
    vm.gridOptions.virtualizationThreshold = vm.gridOptions.minRowsToShow;
  }

  function getRcuSsh(rcu) {
    if (rcu.kind === 'PHYSICAL') {
      if (rcu.ip.startsWith(NETBIRD_IP_START)) {
        return `ssh intelliadmin@${rcu.ip}`;
      } else if (rcu.ip.startsWith(TEN_T_IP_START)) {
        return `ssh petrocloud@${rcu.ip}`;
      } else if (rcu.ip && rcu.port) {
        const user = _.includes(_.get(rcu, ['version', 'distro']), 'Raspbian GNU/Linux 7') ? 'pi' : 'petrocloud';
        const minusPort = 58;
        rcu.sshPort = parseInt(rcu.port, 10) - minusPort;
        return `ssh -p ${rcu.sshPort} ${user}@${rcu.ip}`;
      }
    }
    return '';
  }

  /**
   * Select an RCU
   * (Reinitialize the grid with the associated equipment)
   * If passed RCU is already selected, it is deselected* and the grid inits with all equipment
   *
   * @param {object | string} [rcu=vm.currentEquipment.rcu] Literal or an ID
   * @returns {Promise<undefined>}
   */
  async function selectRcu(rcu = vm.currentEquipment.rcu) {
    rcu = rcu || vm.currentRcu || vm.currentEquipment?.rcu; // handle deselection sending `null`
    if (!_.isObject(rcu)) {
      rcu = await RcuInfoService.getRcuById(rcu);
    }
    if (!rcu) {
      // assuming user doesn't have access to the RCU, only the equipment
      vm.currentRcu = undefined;
      vm.currentEquipmentRcu = undefined;
      return;
    }

    // Deselection
    if (vm.currentRcu && vm.currentRcu.id === rcu.id) {
      vm.currentRcu = undefined;
      vm.currentEquipmentRcu = undefined;
      $state.go('admin.equipment');
    } else {
      vm.currentRcu = rcu;
      vm.currentRcu.ssh = getRcuSsh(rcu);
      vm.currentEquipmentRcu = vm.currentRcu;

      // Deselect equipment if not associated with our RCU
      if (!rcu.equipment.includes(vm.currentEquipment?.id)) {
        vm.currentEquipment = undefined;
        $state.go('admin.equipment');
      }
    }
    return vm.currentRcu ?
      updateGridWithRCU() :
      updateGridWithEquipment();
  }

  function syncRcu(forceSync) {
    let growlMessage = growl.info('Attempting to sync rcu.', { disableCloseButton: true });
    return RcuService.syncRcus(vm.currentRcu.id, forceSync)
      .then(({ data }) => {
        growlMessage.destroy();
        growlMessage = growl.success('Rcu successfully synced!');
        if (data.deleted && data.synchronized) {
          vm.currentRcu = null;
        }
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(_.get(err, 'error', err), { title: 'Could not sync rcu: ' });
        return $q.reject();
      });
  }

  function syncRcuModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Sync Rcu',
      optionalWarning: 'This will overwrite all of the current settings on the RCU. Do this with caution.',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will be synced.`,
      additionalOptionMessage: 'Force sync upon failure',
      onConfirm: syncRcu
    });
  }

  function suggestSyncModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Sync RCU',
      optionalWarning: 'You just deleted an equipment node from the platform. ' +
        'This change will not be reflected without a sync',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will be synced.`,
      onConfirm: syncRcu,
      danger: false,
    });
  }

  function powerCycleCellular() {
    if (_.get(vm.currentRcu, 'settings.powerCycling') === 'none') {
      return powerCycleNotSet('Cellular')
        .then(() => {
          openRcuModal(true);
        });
    }
    let growlMessage;
    return ModalService.confirmationModal({
      modalTitle: 'Confirm',
      optionalWarning: 'This will attempt to power cycle the RCU switch. ' +
        'If misconfigured or disabled, this will not work',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will power cycle its switch.`
    })
      .then(() => {
        growlMessage = growl.info('Sending request to power cycle…', { disableCloseButton: true });
        return RcuService.powerCycleCellular(vm.currentRcu.id);
      })
      .then(() => {
        growlMessage.destroy();
        growlMessage = growl.success('The request to power cycle was successfully completed');
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Request could not be completed:' });
      });
  }

  function powerCycleEquipment() {
    if (_.get(vm.currentRcu, 'settings.powerCycling') === 'none') {
      return powerCycleNotSet('Equipment')
        .then(() => {
          openRcuModal(true);
        });
    }
    let growlMessage;
    return ModalService.confirmationModal({
      modalTitle: 'Confirm',
      optionalWarning: 'This will attempt to power cycle the equipment connected to this RCU. ' +
        'If misconfigured or disabled, this will not work',
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will power cycle the computing unit.`,
      onConfirm: () => {
        growlMessage = growl.info('Sending request to power cycle…', { disableCloseButton: true });
        RcuService
          .powerCycleEquipment(vm.currentRcu.id)
          .then(() => {
            growlMessage.destroy();
            growlMessage = growl.success('The request to power cycle was successfully completed');
          })
          .catch((err) => {
            growlMessage.destroy();
            growlMessage = growl.error(err, { title: 'Request could not be completed:' });
          });
      }
    });
  }

  function powerCycleNotSet(type) {
    return ModalService.confirmationModal({
      modalTitle: `Power Cycle ${type}`,
      optionalWarning: 'Power cycling not configured for this RCU.',
      selectionCriteria: `Click "Confirm Action" to edit RCU ${vm.currentRcu.name} and set a power cycling method.`
    });
  }

  function deleteRcu() {
    let growlMessage = growl.info('Attempting to delete RCU', { disableCloseButton: true });
    return RcuService
      .deleteRcu(vm.currentRcu.id)
      .then(() => {

        growlMessage.destroy();
        _.forEach(vm.currentRcu.equipment, (id) => {
          const foundEquipInd = _.findIndex(allEquipment, ['id', id]);
          if (foundEquipInd > -1) {
            allEquipment.splice(foundEquipInd, 1);
          }
        });

        return ModalService.confirmationModal({
          modalTitle: 'Sync Rcu',
          optionalWarning: 'You just deleted the RCU from the platform. ' +
            'You should perform a Sync in order to clear the RCU local database',
          selectionCriteria: `The RCU "${vm.currentRcu.name}" will be synced.`,
          additionalOptionMessage: 'Force sync upon failure'
        })
          .then((forceSync) => {
            growlMessage = growl.info('Attempting to sync rcu.', { disableCloseButton: true });
            return RcuService.syncRcus(vm.currentRcu.id, forceSync);
          })
          .then(() => {
            growlMessage.destroy();
            growlMessage = growl.success('Rcu successfully synced!');
          })
          .catch((err) => {
            growlMessage.destroy();
            growlMessage = growl.error(err, { title: 'Something went wrong:' });
          })
          .finally(() => {
            vm.currentRcu.equipment = [];
            vm.currentRcu = null;
            vm.currentEquipmentRcu = null;
            updateGridWithEquipment();
          });
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Could not delete RCU' });
      });
  }

  function deleteRcuModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Delete RCU',
      optionalWarning: `
        This will delete the RCU from the platform.
        This change will not be reflected on the RCU without a sync.
      `,
      selectionCriteria: `The RCU "${vm.currentRcu.name}" will be removed.`,
      onConfirm: deleteRcu
    });
  }

  function deleteEquipment() {
    const { id } = vm.currentEquipment;

    let growlMessage = growl.info('Attempting to delete equipment.', { disableCloseButton: true });
    EquipmentService
      .deleteEquipment(id)
      .then(() => {
        _.remove(allEquipment, { id });

        growlMessage.destroy();
        growlMessage = growl.success('Equipment successfully deleted!');

        if (vm.currentRcu) {
          updateGridWithRCU();
        } else {
          updateGridWithEquipment();
        }
        if (vm.currentRcu?.kind === 'PHYSICAL') {
          suggestSyncModal();
        } // TODO: Make sure virtual RCUs update in view too
      })
      .catch((err) => {
        growlMessage.destroy();
        growlMessage = growl.error(err, { title: 'Could not delete equipment: ' });
      });
  }

  function deleteEquipmentModal() {
    return ModalService.confirmationModal({
      modalTitle: 'Delete Equipment',
      optionalWarning: 'This will delete the equipment from the platform. ' +
        'This change will not be reflected on the RCU without a sync.',
      onConfirm: deleteEquipment
    });
  }

  function disableEvents() {
    const modalInstance = $uibModal.open({
      ...disableEventsModal,
      size: 'lg',
      resolve: {
        selectedEquipment() {
          const equipmentToDisable = {};
          equipmentToDisable[vm.currentEquipment.id] = vm.currentEquipment;
          return equipmentToDisable;
        }
      }
    });

    modalInstance.result
      .then((updatedEquipment) => {
        _.forEach(updatedEquipment, (eq) => {
          EquipmentInfoService.updateEquipment(eq);
        });
        // update grid data
        if (vm.currentRcu) {
          updateGridWithRCU();
        } else {
          updateGridWithEquipment();
        }
      });
  }

  // ///////////////////////////////////////////// //
  // scope and instance controllers for the modals //
  // ///////////////////////////////////////////// //

  // instance controller and scope for the rcu modal
  function openRcuModal(edit) {
    $uibModal.open({
      ...addRcuModal,
      size: 'ex-lg',
      resolve: {
        currentRcu() {
          return edit ? vm.currentRcu : false;
        }
      }
    }).result.then((newRcu) => {
      if (newRcu) {
        vm.selectRcu(newRcu);
      }
    });
  }

  /**
   * @param {boolean} editing Whether to open modal for new equipment or the currently selected equipment
   * @returns {Promise} Modal Result
   */
  async function openEquipmentModal(editing) {
    const { id } = vm.currentEquipment || $stateParams;
    editing && !vm.currentEquipment && await selectEquipment(id);
    try {
      const modalResults = _.castArray(await $uibModal.open({
        ...equipmentManagementModal,
        size: 'lg',
        resolve: {
          currentRcu() {
            return vm.currentRcu ||
              vm.currentEquipmentRcu ||
              // Monkey patch for cases where partner does not have RCU access
              { name: '', id: vm.currentEquipment.rcu }
            ;
          },
          async equipment() {
            return editing ? EquipmentInfoService.getFreshEquipment(id) : false;
          }
        }
      }).result);

      for await (const equipment of modalResults) {

        // ! Handle only new equipment here, edits should propagate from reference
        const equipmentParent = _.find(vm.allRcus, { id: equipment.rcu });
        if (equipmentParent) {
          equipmentParent.synchronized = false;
          // TODO: We should probably rely on socket events here instead
          if (!equipmentParent.equipment) {
            equipmentParent.equipment = [equipment.id]; // ! Remove once RCUs are init with empty arrays
          } else if (!equipmentParent.equipment.includes(equipment.id)) {
            equipmentParent.equipment.push(equipment.id);
          }
        }


        if (!editing) {
          const newEquipment = await EquipmentInfoService.getFullEquipment(equipment.id);

          // Only add equipment if it's not already in the grid
          // data === allEquipment means the RCU is not selected
          if (vm.gridOptions.data !== allEquipment) {
            vm.gridOptions.data.push(newEquipment);
          }
          // It's not possible to programmatically select here during update, so we rely on gridApi-hook fallback
          vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ROW);
        }
      }

      const equipment = modalResults.pop();
      $state.go('admin.equipment.eq', { id: equipment?.id });
    } catch (err) {
      ['backdrop click', 'closed'].includes(err) || console.error(err);
      _.delay(() => {
        const alreadyNavigated = !['admin.equipment.new', 'admin.equipment.edit'].includes($state.current.name);
        alreadyNavigated || window.history.back();
        // Wait is needed to allow $state to update from external navigation
      }, SECOND / 4);
    }
  }

  /**
   * @param {Array<object>} [equipment=allEquipment] *Literal* equipment to insert into grid
   * @returns {undefined}
   */
  function updateGridWithEquipment(equipment = allEquipment) {
    vm.gridOptions.data = equipment;
    vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
    setMinRowsToShow();
  }

  /**
   * @param {object} [rcu] An RCU model
   * @param {string[]} rcu.equipment IDs to populate
   * @param {boolean} [refresh] Should fetch fresh data?
   * @returns {undefined}
   */
  async function updateGridWithRCU(rcu = vm.currentRcu, refresh = false) {
    const { equipment: ids } = rcu;
    const equipment = refresh ?
      await EquipmentInfoService.getFreshEquipment(ids) :
      await EquipmentInfoService.getEquipmentById(ids);
    return $q.resolve(updateGridWithEquipment(equipment));
  }


  function $onDestroy() {
    RcuInfoService.unsubscribeToAdmin();
    transitions.forEach(deregister => deregister());
    vm._cleanupActionsWrapped?.();
  }
}

export default {
  name: 'adminEquipmentComponent',
  template,
  controller: EquipmentController,
  bindings: {
    allOrgs: '<'
  }
};
